module.exports = __webpack_public_path__ + "cerulean_seamstress.jpg?4615022505f6439e0cf0a08ef846275c";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/cerulean_seamstress.jpg
// module id = 613
// module chunks = 0